import React from "react";
import useStepPersistence from "../../Hooks/useStepPersistience";
import AddressInformation from "../../organisms/KNT/AddressInformation";
const AddressInformationContainer = ({ formData, errors, setFormStep, loading, setPreviousStep, }) => {
    const [data, handleChange, handleSubmit] = useStepPersistence({
        postal_code: "",
        street: "",
        house_number: "",
        house_number_addition: "",
        city: "",
        country: "NL",
    }, formData, setFormStep);
    return (React.createElement(AddressInformation, { setPreviousStep: setPreviousStep, onSubmit: handleSubmit, onChange: handleChange, data: Object.assign(Object.assign({}, formData), data), errors: errors, loading: loading }));
};
export default AddressInformationContainer;
